import axios from "axios";
import { API_BASE_URL, DEFAULT_CLINIC_ID } from "./api";

const http = axios.create({
  baseURL: API_BASE_URL,
  // withCredentials: false - We use localStorage + Authorization header instead of cookies
  // to avoid cookie conflicts with other apps on the same domain (clinic-side, etc.)
  withCredentials: false,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const clinicId = localStorage.getItem("clinic_id") || DEFAULT_CLINIC_ID;
  if (clinicId && !config.headers["x-clinic-id"]) {
    config.headers["x-clinic-id"] = clinicId;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("therapist_id");
      localStorage.removeItem("clinic_id");
    }
    return Promise.reject(error);
  }
);

export default http;
